var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.data
    ? _c("div", { staticClass: "favorite-note" }, [
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.data.note,
              expression: "data.note",
            },
          ],
          attrs: {
            rows: "3",
            maxlength: "200",
            placeholder: _vm.$t("favorites.note.empty", { n: 200 }),
          },
          domProps: { value: _vm.data.note },
          on: {
            keyup: _vm.updateNote,
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.data, "note", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "saved", class: { active: _vm.saved } }, [
          _vm._v(_vm._s(_vm.$t("favorites.note.saved"))),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }